// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Enhanced Document Tabs Styling */

/* CSS Variables for consistent theming */
:root {
  --tab-bg-primary: hsl(var(--color-foreground));
  --tab-bg-secondary: #f8fafc;
  --tab-bg-tertiary: #f1f5f9;
  --tab-text-primary: #1e293b;
  --tab-text-secondary: #64748b;
  --tab-text-muted: #94a3b8;
  --tab-border: #e2e8f0;
  --tab-border-light: #f1f5f9;
  --tab-shadow: hsl(var(--color-background) / 0.1);
  --tab-gradient-primary: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
  --tab-gradient-secondary: linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%);
  --tab-gradient-success: linear-gradient(135deg, #10b981 0%, #059669 100%);
  --tab-gradient-warning: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
  --tab-gradient-info: linear-gradient(135deg, #06b6d4 0%, #0891b2 100%);
  --tab-accent: #3b82f6;
  --tab-accent-hover: #2563eb;
}

.dark {
  --tab-bg-primary: #0f172a;
  --tab-bg-secondary: #1e293b;
  --tab-bg-tertiary: #334155;
  --tab-text-primary: #f8fafc;
  --tab-text-secondary: #cbd5e1;
  --tab-text-muted: #94a3b8;
  --tab-border: #334155;
  --tab-border-light: #475569;
  --tab-shadow: hsl(var(--color-background) / 0.3);
  --tab-gradient-primary: linear-gradient(135deg, #1e40af 0%, #1e3a8a 100%);
  --tab-gradient-secondary: linear-gradient(135deg, #6d28d9 0%, #5b21b6 100%);
  --tab-gradient-success: linear-gradient(135deg, #047857 0%, #065f46 100%);
  --tab-gradient-warning: linear-gradient(135deg, #b45309 0%, #92400e 100%);
  --tab-gradient-info: linear-gradient(135deg, #0e7490 0%, #155e75 100%);
  --tab-accent: #3b82f6;
  --tab-accent-hover: #60a5fa;
}

/* Smooth transitions for all interactive elements */
.document-tab-transition {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

/* Hide scrollbar utility */
.scrollbar-hide {
  /* Firefox */
  scrollbar-width: none;
  /* Safari and Chrome */
  -ms-overflow-style: none;
}

.scrollbar-hide::-webkit-scrollbar {
  display: none;
}

/* Tab navigation enhancements */
.tab-navigation {
  position: relative;
  overflow: hidden;
}

.tab-navigation::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 1px;
  background: linear-gradient(90deg, 
    transparent 0%, 
    var(--tab-border) 50%, 
    transparent 100%
  );
}

/* Tab item hover effects */
.tab-item {
  position: relative;
  isolation: isolate;
  background: var(--tab-bg-primary);
  color: var(--tab-text-primary);
  border: 1px solid var(--tab-border);
}

.tab-item::before {
  content: '';
  position: absolute;
  inset: 0;
  border-radius: inherit;
  background: linear-gradient(135deg, var(--tab-bg-secondary), transparent);
  opacity: 0;
  transition: opacity 0.3s ease;
  z-index: -1;
}

.tab-item:hover::before {
  opacity: 1;
}

.tab-item:hover {
  background: var(--tab-bg-secondary);
  border-color: var(--tab-accent);
  transform: translateY(-1px);
}

/* Active tab indicator animation */
.tab-indicator {
  position: absolute;
  bottom: -2px;
  left: 50%;
  transform: translateX(-50%);
  width: 8px;
  height: 8px;
  background: var(--tab-accent);
  border-radius: 50%;
  box-shadow: 0 0 12px var(--tab-accent);
  animation: tab-pulse 2s ease-in-out infinite;
}

@keyframes tab-pulse {
  0%, 100% {
    transform: translateX(-50%) scale(1);
    opacity: 1;
  }
  50% {
    transform: translateX(-50%) scale(1.2);
    opacity: 0.8;
  }
}

/* Content fade animations */
.tab-content-enter {
  opacity: 0;
  transform: translateY(16px);
}

.tab-content-enter-active {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.tab-content-exit {
  opacity: 1;
  transform: translateY(0);
}

.tab-content-exit-active {
  opacity: 0;
  transform: translateY(-16px);
  transition: opacity 0.2s ease, transform 0.2s ease;
}

/* Enhanced card styling for tabs */
.tab-card {
  background: var(--tab-bg-primary);
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
  border: 1px solid var(--tab-border);
  box-shadow: 
    0 1px 3px var(--tab-shadow),
    0 1px 2px var(--tab-shadow);
  transition: all 0.3s ease;
  color: var(--tab-text-primary);
}

.tab-card:hover {
  transform: translateY(-2px);
  box-shadow: 
    0 4px 12px var(--tab-shadow),
    0 2px 4px var(--tab-shadow);
  border-color: var(--tab-accent);
}

/* Loading spinner improvements */
.tab-loading-spinner {
  width: 32px;
  height: 32px;
  border: 3px solid hsl(var(--color-primary) / 0.2);
  border-top: 3px solid var(--tab-accent);
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Progress bar enhancements */
.tab-progress {
  background: var(--tab-gradient-primary);
  background-size: 200% 100%;
  animation: progress-gradient 3s ease infinite;
}

@keyframes progress-gradient {
  0%, 100% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
}

/* Interactive button enhancements */
.tab-button {
  position: relative;
  overflow: hidden;
  transition: all 0.2s ease;
  background: var(--tab-bg-primary);
  color: var(--tab-text-primary);
  border: 1px solid var(--tab-border);
}

.tab-button::after {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(45deg, transparent, var(--tab-bg-secondary), transparent);
  transform: translateX(-100%);
  transition: transform 0.6s ease;
}

.tab-button:hover::after {
  transform: translateX(100%);
}

.tab-button:hover {
  background: var(--tab-bg-secondary);
  border-color: var(--tab-accent);
}

/* Responsive enhancements */
@media (max-width: 640px) {
  .tab-navigation {
    padding: 0.5rem;
  }
  
  .tab-item {
    font-size: 0.875rem;
    padding: 0.5rem 0.75rem;
  }
  
  .tab-card {
    margin: 0.5rem;
    padding: 1rem;
  }
}

@media (min-width: 1024px) {
  .tab-card:hover {
    transform: translateY(-4px);
  }
  
  .tab-item {
    padding: 0.75rem 1.5rem;
  }
}

/* Accessibility improvements */
.tab-item:focus-visible {
  outline: 2px solid var(--tab-accent);
  outline-offset: 2px;
}

/* Enhanced gradients for better visual hierarchy */
.tab-gradient-primary {
  background: var(--tab-gradient-primary);
}

.tab-gradient-secondary {
  background: var(--tab-gradient-secondary);
}

.tab-gradient-success {
  background: var(--tab-gradient-success);
}

.tab-gradient-warning {
  background: var(--tab-gradient-warning);
}

.tab-gradient-info {
  background: var(--tab-gradient-info);
}

/* Utility classes for consistent theming */
.tab-bg-primary {
  background-color: var(--tab-bg-primary);
}

.tab-bg-secondary {
  background-color: var(--tab-bg-secondary);
}

.tab-bg-tertiary {
  background-color: var(--tab-bg-tertiary);
}

.tab-text-primary {
  color: var(--tab-text-primary);
}

.tab-text-secondary {
  color: var(--tab-text-secondary);
}

.tab-text-muted {
  color: var(--tab-text-muted);
}

.tab-border {
  border-color: var(--tab-border);
}

.tab-border-light {
  border-color: var(--tab-border-light);
}

/* Hover and focus states */
.tab-hover-bg:hover {
  background-color: var(--tab-bg-secondary);
}

.tab-hover-border:hover {
  border-color: var(--tab-accent);
}

.tab-focus:focus {
  border-color: var(--tab-accent);
  box-shadow: 0 0 0 2px var(--tab-accent);
}

/* Smooth scrolling for tab navigation */
.tab-scroll-container {
  scroll-behavior: smooth;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.tab-scroll-container::-webkit-scrollbar {
  display: none;
}

/* Badge animations */
.tab-badge {
  animation: badge-pulse 2s ease-in-out infinite;
}

@keyframes badge-pulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/documents/enhanced-tabs.css"],"names":[],"mappings":"AAAA,mCAAmC;;AAEnC,yCAAyC;AACzC;EACE,8CAA8C;EAC9C,2BAA2B;EAC3B,0BAA0B;EAC1B,2BAA2B;EAC3B,6BAA6B;EAC7B,yBAAyB;EACzB,qBAAqB;EACrB,2BAA2B;EAC3B,gDAAgD;EAChD,yEAAyE;EACzE,2EAA2E;EAC3E,yEAAyE;EACzE,yEAAyE;EACzE,sEAAsE;EACtE,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,0BAA0B;EAC1B,2BAA2B;EAC3B,6BAA6B;EAC7B,yBAAyB;EACzB,qBAAqB;EACrB,2BAA2B;EAC3B,gDAAgD;EAChD,yEAAyE;EACzE,2EAA2E;EAC3E,yEAAyE;EACzE,yEAAyE;EACzE,sEAAsE;EACtE,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA,oDAAoD;AACpD;EACE,iDAAiD;AACnD;;AAEA,2BAA2B;AAC3B;EACE,YAAY;EACZ,qBAAqB;EACrB,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA,gCAAgC;AAChC;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX;;;;GAIC;AACH;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iCAAiC;EACjC,8BAA8B;EAC9B,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,sBAAsB;EACtB,yEAAyE;EACzE,UAAU;EACV,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mCAAmC;EACnC,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA,mCAAmC;AACnC;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,UAAU;EACV,WAAW;EACX,6BAA6B;EAC7B,kBAAkB;EAClB,sCAAsC;EACtC,4CAA4C;AAC9C;;AAEA;EACE;IACE,oCAAoC;IACpC,UAAU;EACZ;EACA;IACE,sCAAsC;IACtC,YAAY;EACd;AACF;;AAEA,4BAA4B;AAC5B;EACE,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,wBAAwB;EACxB,kDAAkD;AACpD;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,UAAU;EACV,4BAA4B;EAC5B,kDAAkD;AACpD;;AAEA,mCAAmC;AACnC;EACE,iCAAiC;EACjC,mCAA2B;UAA3B,2BAA2B;EAC3B,mCAAmC;EACnC;;+BAE6B;EAC7B,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;EAC3B;;+BAE6B;EAC7B,+BAA+B;AACjC;;AAEA,iCAAiC;AACjC;EACE,WAAW;EACX,YAAY;EACZ,iDAAiD;EACjD,uCAAuC;EACvC,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA,8BAA8B;AAC9B;EACE,uCAAuC;EACvC,0BAA0B;EAC1B,6CAA6C;AAC/C;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,6BAA6B;EAC/B;AACF;;AAEA,oCAAoC;AACpC;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,iCAAiC;EACjC,8BAA8B;EAC9B,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,qFAAqF;EACrF,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA,4BAA4B;AAC5B;EACE;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,cAAc;IACd,aAAa;EACf;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA,+BAA+B;AAC/B;EACE,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA,mDAAmD;AACnD;EACE,uCAAuC;AACzC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,oCAAoC;AACtC;;AAEA,2CAA2C;AAC3C;EACE,uCAAuC;AACzC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,qCAAqC;AACvC;;AAEA,2BAA2B;AAC3B;EACE,yCAAyC;AAC3C;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;EAC/B,uCAAuC;AACzC;;AAEA,wCAAwC;AACxC;EACE,uBAAuB;EACvB,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA,qBAAqB;AACrB;EACE,8CAA8C;AAChD;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;AACF","sourcesContent":["/* Enhanced Document Tabs Styling */\n\n/* CSS Variables for consistent theming */\n:root {\n  --tab-bg-primary: hsl(var(--color-foreground));\n  --tab-bg-secondary: #f8fafc;\n  --tab-bg-tertiary: #f1f5f9;\n  --tab-text-primary: #1e293b;\n  --tab-text-secondary: #64748b;\n  --tab-text-muted: #94a3b8;\n  --tab-border: #e2e8f0;\n  --tab-border-light: #f1f5f9;\n  --tab-shadow: hsl(var(--color-background) / 0.1);\n  --tab-gradient-primary: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);\n  --tab-gradient-secondary: linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%);\n  --tab-gradient-success: linear-gradient(135deg, #10b981 0%, #059669 100%);\n  --tab-gradient-warning: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);\n  --tab-gradient-info: linear-gradient(135deg, #06b6d4 0%, #0891b2 100%);\n  --tab-accent: #3b82f6;\n  --tab-accent-hover: #2563eb;\n}\n\n.dark {\n  --tab-bg-primary: #0f172a;\n  --tab-bg-secondary: #1e293b;\n  --tab-bg-tertiary: #334155;\n  --tab-text-primary: #f8fafc;\n  --tab-text-secondary: #cbd5e1;\n  --tab-text-muted: #94a3b8;\n  --tab-border: #334155;\n  --tab-border-light: #475569;\n  --tab-shadow: hsl(var(--color-background) / 0.3);\n  --tab-gradient-primary: linear-gradient(135deg, #1e40af 0%, #1e3a8a 100%);\n  --tab-gradient-secondary: linear-gradient(135deg, #6d28d9 0%, #5b21b6 100%);\n  --tab-gradient-success: linear-gradient(135deg, #047857 0%, #065f46 100%);\n  --tab-gradient-warning: linear-gradient(135deg, #b45309 0%, #92400e 100%);\n  --tab-gradient-info: linear-gradient(135deg, #0e7490 0%, #155e75 100%);\n  --tab-accent: #3b82f6;\n  --tab-accent-hover: #60a5fa;\n}\n\n/* Smooth transitions for all interactive elements */\n.document-tab-transition {\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n/* Hide scrollbar utility */\n.scrollbar-hide {\n  /* Firefox */\n  scrollbar-width: none;\n  /* Safari and Chrome */\n  -ms-overflow-style: none;\n}\n\n.scrollbar-hide::-webkit-scrollbar {\n  display: none;\n}\n\n/* Tab navigation enhancements */\n.tab-navigation {\n  position: relative;\n  overflow: hidden;\n}\n\n.tab-navigation::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 1px;\n  background: linear-gradient(90deg, \n    transparent 0%, \n    var(--tab-border) 50%, \n    transparent 100%\n  );\n}\n\n/* Tab item hover effects */\n.tab-item {\n  position: relative;\n  isolation: isolate;\n  background: var(--tab-bg-primary);\n  color: var(--tab-text-primary);\n  border: 1px solid var(--tab-border);\n}\n\n.tab-item::before {\n  content: '';\n  position: absolute;\n  inset: 0;\n  border-radius: inherit;\n  background: linear-gradient(135deg, var(--tab-bg-secondary), transparent);\n  opacity: 0;\n  transition: opacity 0.3s ease;\n  z-index: -1;\n}\n\n.tab-item:hover::before {\n  opacity: 1;\n}\n\n.tab-item:hover {\n  background: var(--tab-bg-secondary);\n  border-color: var(--tab-accent);\n  transform: translateY(-1px);\n}\n\n/* Active tab indicator animation */\n.tab-indicator {\n  position: absolute;\n  bottom: -2px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 8px;\n  height: 8px;\n  background: var(--tab-accent);\n  border-radius: 50%;\n  box-shadow: 0 0 12px var(--tab-accent);\n  animation: tab-pulse 2s ease-in-out infinite;\n}\n\n@keyframes tab-pulse {\n  0%, 100% {\n    transform: translateX(-50%) scale(1);\n    opacity: 1;\n  }\n  50% {\n    transform: translateX(-50%) scale(1.2);\n    opacity: 0.8;\n  }\n}\n\n/* Content fade animations */\n.tab-content-enter {\n  opacity: 0;\n  transform: translateY(16px);\n}\n\n.tab-content-enter-active {\n  opacity: 1;\n  transform: translateY(0);\n  transition: opacity 0.3s ease, transform 0.3s ease;\n}\n\n.tab-content-exit {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n.tab-content-exit-active {\n  opacity: 0;\n  transform: translateY(-16px);\n  transition: opacity 0.2s ease, transform 0.2s ease;\n}\n\n/* Enhanced card styling for tabs */\n.tab-card {\n  background: var(--tab-bg-primary);\n  backdrop-filter: blur(10px);\n  border: 1px solid var(--tab-border);\n  box-shadow: \n    0 1px 3px var(--tab-shadow),\n    0 1px 2px var(--tab-shadow);\n  transition: all 0.3s ease;\n  color: var(--tab-text-primary);\n}\n\n.tab-card:hover {\n  transform: translateY(-2px);\n  box-shadow: \n    0 4px 12px var(--tab-shadow),\n    0 2px 4px var(--tab-shadow);\n  border-color: var(--tab-accent);\n}\n\n/* Loading spinner improvements */\n.tab-loading-spinner {\n  width: 32px;\n  height: 32px;\n  border: 3px solid hsl(var(--color-primary) / 0.2);\n  border-top: 3px solid var(--tab-accent);\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n/* Progress bar enhancements */\n.tab-progress {\n  background: var(--tab-gradient-primary);\n  background-size: 200% 100%;\n  animation: progress-gradient 3s ease infinite;\n}\n\n@keyframes progress-gradient {\n  0%, 100% {\n    background-position: 0% 50%;\n  }\n  50% {\n    background-position: 100% 50%;\n  }\n}\n\n/* Interactive button enhancements */\n.tab-button {\n  position: relative;\n  overflow: hidden;\n  transition: all 0.2s ease;\n  background: var(--tab-bg-primary);\n  color: var(--tab-text-primary);\n  border: 1px solid var(--tab-border);\n}\n\n.tab-button::after {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(45deg, transparent, var(--tab-bg-secondary), transparent);\n  transform: translateX(-100%);\n  transition: transform 0.6s ease;\n}\n\n.tab-button:hover::after {\n  transform: translateX(100%);\n}\n\n.tab-button:hover {\n  background: var(--tab-bg-secondary);\n  border-color: var(--tab-accent);\n}\n\n/* Responsive enhancements */\n@media (max-width: 640px) {\n  .tab-navigation {\n    padding: 0.5rem;\n  }\n  \n  .tab-item {\n    font-size: 0.875rem;\n    padding: 0.5rem 0.75rem;\n  }\n  \n  .tab-card {\n    margin: 0.5rem;\n    padding: 1rem;\n  }\n}\n\n@media (min-width: 1024px) {\n  .tab-card:hover {\n    transform: translateY(-4px);\n  }\n  \n  .tab-item {\n    padding: 0.75rem 1.5rem;\n  }\n}\n\n/* Accessibility improvements */\n.tab-item:focus-visible {\n  outline: 2px solid var(--tab-accent);\n  outline-offset: 2px;\n}\n\n/* Enhanced gradients for better visual hierarchy */\n.tab-gradient-primary {\n  background: var(--tab-gradient-primary);\n}\n\n.tab-gradient-secondary {\n  background: var(--tab-gradient-secondary);\n}\n\n.tab-gradient-success {\n  background: var(--tab-gradient-success);\n}\n\n.tab-gradient-warning {\n  background: var(--tab-gradient-warning);\n}\n\n.tab-gradient-info {\n  background: var(--tab-gradient-info);\n}\n\n/* Utility classes for consistent theming */\n.tab-bg-primary {\n  background-color: var(--tab-bg-primary);\n}\n\n.tab-bg-secondary {\n  background-color: var(--tab-bg-secondary);\n}\n\n.tab-bg-tertiary {\n  background-color: var(--tab-bg-tertiary);\n}\n\n.tab-text-primary {\n  color: var(--tab-text-primary);\n}\n\n.tab-text-secondary {\n  color: var(--tab-text-secondary);\n}\n\n.tab-text-muted {\n  color: var(--tab-text-muted);\n}\n\n.tab-border {\n  border-color: var(--tab-border);\n}\n\n.tab-border-light {\n  border-color: var(--tab-border-light);\n}\n\n/* Hover and focus states */\n.tab-hover-bg:hover {\n  background-color: var(--tab-bg-secondary);\n}\n\n.tab-hover-border:hover {\n  border-color: var(--tab-accent);\n}\n\n.tab-focus:focus {\n  border-color: var(--tab-accent);\n  box-shadow: 0 0 0 2px var(--tab-accent);\n}\n\n/* Smooth scrolling for tab navigation */\n.tab-scroll-container {\n  scroll-behavior: smooth;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n}\n\n.tab-scroll-container::-webkit-scrollbar {\n  display: none;\n}\n\n/* Badge animations */\n.tab-badge {\n  animation: badge-pulse 2s ease-in-out infinite;\n}\n\n@keyframes badge-pulse {\n  0%, 100% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(1.05);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
